import React, { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
interface Props {}

export default function LoadingText({}: Props) {
  const { t } = useTranslation()
  
  return (
    <Dots className="dot1">
      {t("rawText.loading")}
      <Dot />
      <Dot />
      <Dot />
    </Dots>
  );
}

export const Dot = styled.label`
  ::before {
    content: ".";
  }
  color: black;
`;

 export const Dots = styled.label`
  label:nth-child(1) {
    animation-delay: 0s;
  }

  label:nth-child(2) {
    animation-delay: 0.2s;
  }

  label:nth-child(3) {
    animation-delay: 0.4s;
  }

  label {
    border-radius: 50%;
    animation: outSide 1.2s linear forwards infinite;
  }

  @keyframes outSide {
    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
`;
